import React, { useEffect, Suspense } from 'react';
import { BrowserRouter as Router, Switch, withRouter, } from 'react-router-dom';
import AppContainer from './AppContainer';
import { useDispatch, useSelector } from 'react-redux';
import { alertActions } from './actions/alert.actions';
//@ts-ignore
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import PrivateRoute from './components/Route/PrivateRoute';
import PublicRoute from './components/Route/PublicRoute';
import GlobalModal from 'components/Modal/GlobalModal';

// Import ErrorBoundary directly (not lazy) since it needs to catch errors from lazy components
import ErrorBoundary from './components/Base/ErrorBoundary';

// Lazy load heavy components for better performance
const ErrorPage = React.lazy(() => import('./routing/ErrorPage'));
const NotFoundPage = React.lazy(() => import('./routing/NotFoundPage'));
const Briks = React.lazy(() => import('./routing/Briks'));
const AppInfoPage = React.lazy(() => import('./routing/AppInfoPage'));
const CustomerPage = React.lazy(() => import('./routing/CustomerPage'));
const GroupPage = React.lazy(() => import('./routing/CustomerPage/Customer/Group'));
const UserStatus = React.lazy(() => import('./routing/CustomerPage/UserStatus'));
const CustomerBrikView = React.lazy(() => import('./routing/CustomerPage/Brik/view'));
const CustomerBrikContent = React.lazy(() => import('./routing/CustomerPage/Brik/contents'));
const LoginPage = React.lazy(() => import('./routing/LoginPage'));
const ForgotPassword = React.lazy(() => import('./routing/ForgotPassword'));
const ResetPassword = React.lazy(() => import('./routing/ResetPassword'));
const ProfileSettings = React.lazy(() => import('./routing/ProfileSettings'));
const BrikContentPage = React.lazy(() => import('./routing/BrikContentPage'));
const Dashboard = React.lazy(() => import('./routing/Dashboard'));
const BrikDetailsPage = React.lazy(() => import('./routing/BrikDetailsPage'));
const SubcriptionExpired = React.lazy(() => import('./routing/SubcriptionExpired'));
const SubcriptionSuccess = React.lazy(() => import('./routing/SubcriptionSuccess'));
const SubcriptionFail = React.lazy(() => import('./routing/SubcriptionFail'));

// Loading component for Suspense fallback
const LoadingFallback = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh',
    fontSize: '16px',
    color: '#666'
  }}>
    Loading...
  </div>
);

const Routes = (props: any) => {
  const dispatch = useDispatch();

  const alert = useSelector((state: any) => state.alert);
  const { history } = props;

  useEffect(() => {
    const { type = '', message = '' } = alert;
    if (type && message) {
      NotificationManager[type.toLowerCase()](message);
      const listNotification = NotificationManager.listNotify || [];
      // clear all previous notification
      if (listNotification.length > 1) {
        listNotification.forEach((notification: any, index: number) => {
          if (index !== listNotification.length - 1) {
            NotificationManager.remove({ id: notification.id });
          }
        });
      }
    }
  }, [alert]);

  useEffect(() => {
    history.listen(() => {
      dispatch(alertActions.clear());
    });
  }, [dispatch]);

  return (
    <div>
      <Suspense fallback={<LoadingFallback />}>
        <Switch>
          <PrivateRoute component={Dashboard} path="/" exact />
          <PrivateRoute component={Dashboard} path="/dashboard" exact />
          <PrivateRoute component={Briks} path="/briks" exact />
          <PrivateRoute component={BrikDetailsPage} path="/brik/detail/:id" exact />
          <PrivateRoute component={BrikContentPage} path="/brik/:id/content/:contentId/type/:type" exact />
          <PrivateRoute component={AppInfoPage} path="/app-info" exact />
          <PrivateRoute component={CustomerPage} path="/customer" exact />
          <PrivateRoute component={GroupPage} path="/customer/group/:id" exact />
          <PrivateRoute component={UserStatus} path="/customer/user-status/:id" exact />
          <PrivateRoute component={CustomerBrikView} path="/customer/birk/view/:id" exact />
          <PrivateRoute component={CustomerBrikContent} path="/customer/brik/content/:id" exact />
          <PublicRoute key="login" restricted component={LoginPage} path="/login" exact />
          <PublicRoute key="register" restricted component={LoginPage} path="/register" exact />
          <PublicRoute restricted component={SubcriptionExpired} path="/subcription-expired" exact />
          <PrivateRoute component={SubcriptionSuccess} path="/subcription-success" exact />
          <PrivateRoute component={SubcriptionFail} path="/subcription-fail" exact />
          <PublicRoute
            restricted={false}
            component={ForgotPassword}
            path="/forgot-password"
            exact
          />
          <PublicRoute
            restricted={false}
            component={ResetPassword}
            path="/reset-password"
            exact
          />
          <PrivateRoute
            component={ProfileSettings}
            path="/profile-settings"
            exact
          />
          <PublicRoute restricted component={ErrorPage} path="/error" exact />
          <PublicRoute restricted component={NotFoundPage} exact />
        </Switch>
      </Suspense>
    </div>
  );
};

const RoutesHistory = withRouter(Routes);
const routing = function createRouting() {
  return (
    <>
      <NotificationContainer />
      <Router>
        <GlobalModal />
        <AppContainer>
          <ErrorBoundary>
            <RoutesHistory />
          </ErrorBoundary>
        </AppContainer>
      </Router>
    </>
  );
};

export default routing;
